import { graphql } from "react-relay";

import { useUpdateUrlMappingActive_Mutation } from "~/src/__relay_artifacts__/useUpdateUrlMappingActive_Mutation.graphql";
import { useMutationCommit } from "~/src/lib/react-relay";

const mutation = graphql`
  mutation useUpdateUrlMappingActive_Mutation($input: UpdateUrlMappingInput!) {
    updateUrlMapping(input: $input) {
      urlMapping {
        id
        active
      }
    }
  }
`;

export const useUpdateUrlMappingActive = () => {
  const updateUrlMappingActive =
    useMutationCommit<useUpdateUrlMappingActive_Mutation>(mutation);

  return { updateUrlMappingActive };
};
